export enum Conjunction {
  AND = 'AND',
  OR = 'OR',
}

export enum Operator {
  EQUALS = '=',
  NOT_EQUALS = '<>',
}

export type QueryExpression = {
  id: string;
  property: string;
  operator: string;
  value: string;
  conjunction?: Conjunction;
  expressions?: QueryExpression[];
};
